import React, { useState } from 'react';
import { Tabs } from 'antd';
import ItemAvailabilityInquiry from './ItemAvailabilityInquiry';
import ShipToInquiry from './ShipToInquiry';
import './IASTIInquiry.less';

const { TabPane } = Tabs;

export default function IASTIInquiry() {
    const [activeTab, setActiveTab] = useState('item-availability');

    const onTabChange = (key) => {
        setActiveTab(key);
    };

    return (
        <div className="ia-sti-inquiry-container">
            <div className="ia-sti-inquiry-header">
                <h2>IA and STI Inquiry</h2>
            </div>
            <Tabs
                activeKey={activeTab}
                onChange={onTabChange}
                className="ia-sti-tabs"
            >
                <TabPane
                    tab={<span>IA - Item Availability Inquiry</span>}
                    key="item-availability"
                >
                    <ItemAvailabilityInquiry />
                </TabPane>
                <TabPane
                    tab={<span>STI - Ship-To Inquiry</span>}
                    key="ship-to"
                >
                    <ShipToInquiry />
                </TabPane>
            </Tabs>
        </div>
    );
}


